import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  fieldObjectGlossario,
  headersGlossario,
  valoresExibidosOffCanvasGlossario,
} from './auxiliarGlossario';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useTipoTermoGlossario } from '../../../../services/enum/useTipoTermoGlossario';
import { getAllGlossario } from '../../../../services/home/glossarioService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../utils/functions';
import subAbas from '../subabas';

//Dados do usuário
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_Glossario;

const GlossarioIndex: React.FC = () => {
  const navigate = useNavigate();
  const tipoTermo = useTipoTermoGlossario();

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    tipoTermo: 0,
    nomeTermo: '',
  });
  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllGlossario();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  //Dados da tabela
  const tableData = data
    .filter((item: any) => {
      return (
        (formFiltros.nomeTermo === '' ||
          item.nomeTermo
            .toLowerCase()
            .includes(formFiltros.nomeTermo.toLowerCase())) &&
        (formFiltros.tipoTermo === 0 ||
          item.tipoTermo === Number(formFiltros.tipoTermo))
      );
    })
    .map((item) => {
      return {
        id: item.id,
        tipoTermo: tipoTermo[item.tipoTermo].label,
        nomeTermo: <b>{item.nomeTermo.toUpperCase()}</b>,
      };
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,

    separadorLog: '',

    tipoTermo: tipoTermo[item.tipoTermo].label,
    nomeTermo: <b>{item.nomeTermo.toUpperCase()}</b>,
    descricao: item.descricao,
    sinonimos: item.sinonimos ? item.sinonimos : 'Não informado',
    afeicoes: item.afeicoes ? item.afeicoes : 'Não informado',
    maisInformacoes:
      item.maisInformacoes === '' ? (
        'Não informado'
      ) : (
        <a
          href={item.maisInformacoes}
          target="_blank"
          rel="noopener noreferrer"
        >
          {item.maisInformacoes}
        </a>
      ),

    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setFormFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      tipoTermo: 0,
      nomeTermo: '',
    });
  };

  interface ExportData {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    tipoTermo: number;
    nomeTermo: string;
    descricao: string;
    sinonimos: string;
    afeicoes: string;
    maisInformacoes: string;

    //Observações
    observacoes: string;
  }

  const prepareDataForExport = (data: ExportData[]) => {
    return data.map((item) => {
      return {
        id: item.id,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        //Específicos
        tipoTermo: tipoTermo[item.tipoTermo].label,
        nomeTermo: item.nomeTermo || '-',
        descricao: item.descricao || '-',
        sinonimos: item.sinonimos || 'Não informado',
        afeicoes: item.afeicoes || 'Não informado',
        maisInformacoes: item.maisInformacoes || 'Não informado',

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  const filteredDataForExport = data.filter((item) => {
    return (
      (formFiltros.nomeTermo === '' ||
        item.nomeTermo
          .toLowerCase()
          .includes(formFiltros.nomeTermo.toLowerCase())) &&
      (formFiltros.tipoTermo === 0 ||
        item.tipoTermo === Number(formFiltros.tipoTermo))
    );
  });

  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="200px">
              <SelectInput
                name="tipoTermo"
                options={tipoTermo}
                label="Tipo de Termo"
                value={formFiltros.tipoTermo}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol>
              <Input
                name="nomeTermo"
                label="Termo Técnico"
                value={formFiltros.nomeTermo}
                id="nomeTermo"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersGlossario}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosOffCanvasGlossario}
          tituloCanvas="GLOSSÁRIO"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              prepareDataForExport(filteredDataForExport),
              valoresExibidosOffCanvasGlossario,
              fieldObjectGlossario,
              'sisaf_glossario.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default GlossarioIndex;
